import type { CatalogResource } from '../../types.js';
import { FEATURE_GROUP_KEYS } from '../feature-groups.js';
import { ROLE_KEYS } from '../roles.js';

const GROUP = FEATURE_GROUP_KEYS.REPORTS;
const defaultGrants = {
  [ROLE_KEYS.COMPANY_ADMIN]: 'all',
  [ROLE_KEYS.COMPANY_CREATOR]: 'all',
  [ROLE_KEYS.COMPANY_READER]: ['read'],
} as const;

export const reports = [
  {
    key: 'reports',
    name: 'Reports',
    description: 'Analytics and exports',
    // Read-only feature — every other action is N/A.
    group: GROUP,
    actions: ['read'],
    grants: defaultGrants,
  },
] as const satisfies readonly CatalogResource[];
